import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { SystemRoleName } from '@evimo/types/enums/system-role-name';
import { useAuth } from '~/app/auth/context/AuthContext';
import {
  PLAN_DETAIL_TABLE_PAGE_SIZE,
  PreventiveMaintenanceService,
  type PlanDetailTablePagination,
} from '~/app/services/preventive-maintenance/preventive-maintenance.service';

export function useSchedules(
  planId: string | undefined,
  pagination: PlanDetailTablePagination = {
    page: 1,
    limit: PLAN_DETAIL_TABLE_PAGE_SIZE,
  },
) {
  const { user } = useAuth();
  const isSuperAdmin = user?.roleName === SystemRoleName.SUPER_ADMIN;
  const organizationId = user?.organizationId ?? '';
  const scopeKey = isSuperAdmin ? 'all-orgs' : organizationId;

  const query = useQuery({
    queryKey: [
      'preventive-maintenance',
      'schedules',
      planId,
      scopeKey,
      pagination.page,
      pagination.limit,
    ],
    queryFn: async () =>
      PreventiveMaintenanceService.listSchedules(planId!, pagination),
    enabled: (isSuperAdmin || !!organizationId) && !!planId,
    placeholderData: keepPreviousData,
  });

  return {
    schedules: query.data?.data ?? [],
    meta: query.data?.meta ?? {
      total: 0,
      page: pagination.page,
      limit: pagination.limit,
      totalPages: 0,
    },
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error as Error | null,
  };
}
